import { useEffect, useRef } from 'react';
export const useResizeObserver = (callback) => {
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current) {
            const resizeObserver = new ResizeObserver((entries) => {
                callback(entries?.[0]?.contentRect);
            });
            resizeObserver.observe(ref.current);
            return () => {
                resizeObserver.disconnect();
            };
        }
        return () => null;
    }, [ref, callback]);
    return ref;
};
//# sourceMappingURL=useResizeObserver.js.map